<template>
  <div>
    <v-form ref="advanceForm">
      <v-row class="d-flex">
        <v-col cols="3">
          <v-menu
            ref="menu"
            v-model="menu"
            :close-on-content-click="false"
            transition="scale-transition"
            offset-y
            min-width="auto"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                v-model="formattedDate"
                label="Previsão de pagamento"
                prepend-icon="mdi-calendar"
                readonly
                v-bind="attrs"
                v-on="on"
                clearable
                @click:clear="$emit('update:forecastPayment', null)"
                :rules="
                  (validateFields && transformPriceToSend(localAdvanceAmount) != 0) || validationOfAdditionals
                    ? rules
                    : []
                "
              ></v-text-field>
            </template>
            <v-date-picker v-model="localForecastPayment" locale="pt-br" @change="emitForecastPayment"></v-date-picker>
          </v-menu>
        </v-col>
        <v-col cols="3">
          <v-text-field
            ref="AdvanceAmount"
            v-model="localAdvanceAmount"
            @input="updateAdvanceAmount"
            v-money="money"
            label="Valor do adiantamento"
            hide-details
            :rules="(validateFields && formattedDate) || validationOfAdditionals ? amountRules : []"
          ></v-text-field>
        </v-col>
      </v-row>
    </v-form>
  </div>
</template>

<script>
import { VMoney } from 'v-money';

export default {
  props: {
    advanceAmount: {
      default: null,
      type: String
    },
    forecastPayment: {
      default: null,
      type: String
    },
    validateFields: {
      default: false,
      type: Boolean
    },
    validationOfAdditionals: {
      default: false,
      type: Boolean
    }
  },
  directives: { money: VMoney },
  data() {
    return {
      menu: false,
      money: {
        decimal: ',',
        thousands: '.',
        prefix: 'R$ ',
        suffix: '',
        precision: 2,
        masked: false
      },
      localForecastPayment: null,
      localAdvanceAmount: null,
      rules: [(v) => !!v || 'Required.'],
      amountRules: [(v) => !this.transformPriceToSend(v) == 0 || 'Required.']
    };
  },
  mounted() {
    this.localForecastPayment = this.forecastPayment;
    this.localAdvanceAmount = this.advanceAmount;
  },
  computed: {
    formattedDate: {
      get() {
        return this.forecastPayment ? this.forecastPayment.split('-').reverse().join('/') : '';
      },
      set(newValue) {
        this.$emit('update:forecastPayment', newValue);
        return newValue;
      }
    }
  },
  methods: {
    emitForecastPayment() {
      this.$emit('update:forecastPayment', this.localForecastPayment);
    },
    updateAdvanceAmount() {
      const newValue = this.$refs.AdvanceAmount.value;
      this.$emit('update:advanceAmount', newValue);
    },
    transformPriceToSend(element) {
      if (!element) return null;
      var money = element.toString().trim();
      money = money.replace('R$ ', '').replaceAll('.', '').replace(',', '.');
      return Number(money);
    }
  },
  watch: {
    forecastPayment(newValue) {
      this.localForecastPayment = newValue;
    },
    validationOfAdditionals(newValue) {
      if (newValue) {
        this.$refs.advanceForm.validate();
      }
    },
    localForecastPayment() {
      // if (newValue !== null && this.validationOfAdditionals) {
        this.$refs.advanceForm.validate();
      // }
    },
    localAdvanceAmount() {
      // if (newValue !== null && this.validationOfAdditionals) {
        this.$refs.advanceForm.validate();
      // }
    },
    advanceAmount(newValue) {
      if (newValue === null) {
        this.$refs.AdvanceAmount.$el.getElementsByTagName('input')[0].value = 0;
        this.localAdvanceAmount = null;
      } else {
        this.$refs.AdvanceAmount.$el.getElementsByTagName('input')[0].value = newValue;
        this.localAdvanceAmount = newValue;
      }
    }
  }
};
</script>
